import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {BlogService} from '../../shared/blog.service';
import {Observable} from 'rxjs';
import {Blog} from '../../shared/blog';
import {User} from '../../shared/user';

@Component({
  selector: 'app-blogs',
  templateUrl: './blogs.component.html',
  styleUrls: ['./blogs.component.scss']
})
export class BlogsComponent implements OnInit {
  blogs: Observable<Blog[]>;
  @Output()
  blogDetails = new EventEmitter<Blog>();

  constructor(private blogService: BlogService) {
  }

  ngOnInit() {
    this.blogs = this.blogService.getData();
  }

  readBlog(blog: Blog) {
    console.log(blog);
    this.blogDetails.emit(blog);
  }

  addBlog() {
    this.blogDetails.emit(null);
  }

}
